import { useSelector } from "react-redux";
import {
  getCurrentProjectID,
  toastError,
} from "../../../../../../../app_shared_functions";
import { getProjectsObject } from "../../../../../../../selectors/projects";
import { useEffect, useState } from "react";
import FetchAPI from "../../../../../../../api/FetchAPI";
import { DropdownItemProps } from "semantic-ui-react";
import { SubnetPool } from "../../../../../networks/create/types/subnetPool";

const usePoolOptions = (region: string) => {
  const projects = useSelector(getProjectsObject);
  const projectId = getCurrentProjectID(projects, region);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [poolsList, setPoolsList] = useState<SubnetPool[]>([]);
  const [poolsOptions, setPoolsOptions] = useState<DropdownItemProps[]>([]);

  useEffect(() => {
    setLoading(true);
    FetchAPI.Networking.Subnets.getSubnetPools({
      region: region,
      project_id: projectId,
    })
      .then((response) => {
        const data = response.data as SubnetPool[];
        setPoolsList(data);

        const options = data.map((subnetPool, i) => ({
          key: i,
          value: subnetPool.id,
          text: `${subnetPool.name} (Prefix: /${subnetPool["default_prefixlen"]})`,
        }));
        if (options.length === 0) {
          setError("No pools found!");
        }

        setPoolsOptions(options);
      })
      .catch((err) => {
        toastError(err, "Getting subnet pools failed!");
        setError("Error fetching pools list!");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [region, projectId]);

  return {
    loading,
    error,
    poolsOptions,
    poolsList,
  };
};

export default usePoolOptions;
